import SearchIcon from '@mui/icons-material/Search';
import { Box, Typography, useTheme } from '@mui/material';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { bloxValues } from 'themes/constants';

/**
 * --------------------------------------------------------
 * Search Modal Header - Editorial
 * --------------------------------------------------------
 */

export const SearchModalHeaderEditorial = memo(() => {
  const { t } = useTranslation();
  const theme = useTheme();
  const strAssets = t('blox.general.assets');

  return (
    <Box
      data-testid="search-modal-header-editorial"
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        overflow: 'auto',
        gap: 0.5,
      }}
    >
      <SearchIcon
        sx={{
          color: theme.palette.text.secondary,
          fontSize: bloxValues.iconSizeRegular,
        }}
      />
      <Typography
        sx={{
          fontSize: bloxValues.xxlFontSizeRem,
          color: theme.palette.text.secondary,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          wordBreak: 'break-word',
          display: '-webkit-box',
          WebkitBoxOrient: 'vertical',
          WebkitLineClamp: 1,
        }}
      >
        {strAssets}
      </Typography>
    </Box>
  );
});
SearchModalHeaderEditorial.displayName = 'SearchModalHeaderEditorial';
